<div class="login-box">
  <div class="login-box-body login_container">
    <span class="login_heading">Claims Management System</span>
    @if (userForm) {
      <form [formGroup]="UserNameForm">
        <div class="frm_grp">
          <div class="form-group has-feedback">
            <input type="text" name="UserName" class="form-control" placeholder="User Name" formControlName="UserName" required (keypress)="enterKeyPressed($event, 'userNameForm')">
          </div>
          <div class="row login_btn">
            <button class="btn btn-primary btn-block btn-flat sign_in" [ngClass]="{'small_loader': otpSent}" [disabled]="UserNameForm.invalid || disableOTPButtonOnSent" (click)="GetInsurerDetail()">{{OTPText}}</button>
          </div>
          <span>{{respMessage}}</span>
        </div>
      </form>
    }
    @if (!userForm) {
      <form [formGroup]="OTPForm">
        <div class="frm_grp">
          @if (OtpData?.MaskMobileNo && OtpData?.MaskMobileNo != 0 && OtpData?.MaskEmail) {
            <div class="form-group has-feedback">
              One Time Password sent to your registered mobile number {{OtpData?.MaskMobileNo}}
              and registered email {{OtpData?.MaskEmail}}
            </div>
          } @else {
            @if (OtpData?.MaskMobileNo && OtpData?.MaskMobileNo != 0) {
              <div class="form-group has-feedback">
                One Time Password sent to your registered mobile number {{OtpData?.MaskMobileNo}}
              </div>
            } @else {
              <div class="form-group has-feedback">
                One Time Password sent to your Email {{OtpData?.MaskEmail}}
              </div>
            }
          }
          <!-- <div class="form-group has-feedback" *ngIf="OtpData?.MaskMobileNo && OtpData?.MaskMobileNo!=0 && OtpData?.MaskEmail != '' ">
          One Time Password sent to your registered mobile number {{OtpData?.MaskMobileNo}} and registered email  {{OtpData?.MaskEmail}}
        </div>
        <div class="form-group has-feedback" *ngIf="OtpData?.MaskMobileNo && OtpData?.MaskMobileNo!=0">
          One Time Password sent to your registered mobile number {{OtpData?.MaskMobileNo}}
        </div>
        <div class="form-group has-feedback" *ngIf="OtpData?.MaskMobileNo && OtpData?.MaskMobileNo<=0">
          One Time Password sent to your Email {{OtpData?.MaskEmail}}
        </div> -->
        <div class="form-group has-feedback">
          <input type="text" name="otp" class="form-control" placeholder="Enter OTP" formControlName="otp" required (keypress)="enterKeyPressed($event, 'otpForm')">
        </div>
        <div class="row login_btn">
          <button class="btn btn-primary sign_in" [ngClass]="{'small_loader': otpVerify}" [disabled]="OTPForm.invalid" (click)="VerifyOTP()">Submit</button>
          <button class="btn btn-primary sign_in" [ngClass]="{'small_loader': otpSent}" [disabled]="UserNameForm.invalid || disableOTPButtonOnSent" (click)="GetInsurerDetail()">{{OTPText}}</button>
        </div>
        <span>{{respMessage}}</span>
      </div>
    </form>
  }
</div>
</div>
